Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    COLORS = _STYLES$useStyles.COLORS;
  var _height = (0, _styles.getREM)(1.75);
  var container = {
    backgroundColor: colors.defaultCategoryPillBackground,
    borderRadius: (0, _styles.getREM)(0.375),
    alignSelf: 'flex-start',
    justifyContent: 'center',
    alignItems: 'center',
    height: _height,
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden',
    borderWidth: 0
  };
  var container_loading = {
    backgroundColor: COLORS.silver,
    width: (0, _styles.getREM)(8)
  };
  var icon = Object.assign({
    width: (0, _styles.getREM)(1),
    height: (0, _styles.getREM)(1),
    marginRight: spacing.xxs
  }, _reactNative.Platform.select({
    ios: {
      transform: [{
        translateY: 2
      }]
    }
  }));
  var link = {
    textDecorationLine: 'none'
  };
  var content = {
    paddingLeft: spacing.xs,
    paddingRight: spacing.xs,
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: _height
  };
  var text = Object.assign({}, fontSemiBold, {
    color: colors.defaultCategoryPillText,
    textTransform: 'capitalize',
    fontSize: _styles.STYLES.fontSize.xxs,
    lineHeight: _height
  }, _reactNative.Platform.select({
    ios: {
      height: _height + 6,
      lineHeight: _height + 10
    }
  }));
  if (bp.is([bp.tablet, bp.desktop])) {
    text.fontSize = _styles.STYLES.fontSize.xs;
  }
  var styles = _reactNative.StyleSheet.create({
    container: container,
    container_loading: container_loading,
    content: content,
    icon: icon,
    link: link,
    text: text
  });
  return {
    styles: styles,
    defaultTextColor: colors.defaultCategoryPillText
  };
};